function sortByIssueId(array) {
  array.sort((a, b) => {
    let fa = a.issueId, fb = b.issueId;
    if (fa > fb) return -1;
    if (fa < fb) return 1;
    return 0;
  });
}

export default sortByIssueId;